import React, { useEffect, useState, useContext } from 'react'
import {
    Box,
    useTheme,
    useMediaQuery,
} from '@mui/material';
import ProjectContext from '../../contexts/ProjectContext';

import { useAuth0 } from "@auth0/auth0-react";

import ShotDetailPageDesktop from './ShotDetailPageDesktop';
import ShotDetailPageMobile from './ShotDetailPageMobile';
import {useFetch} from '../../components/auth/useFetch';

export default function ShotDetailPage(props) {
    const { clipname } = props
    const projectContext = useContext(ProjectContext);

    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down('sm'))
    const isSm = useMediaQuery(theme.breakpoints.down('md'))
    const isMd = useMediaQuery(theme.breakpoints.down('lg'))
    const isLg = useMediaQuery(theme.breakpoints.down('xl'))

    const { isAuthenticated } = useAuth0();
    const [shotData, setShotData] = useState({})
    const fetchWithAuth = useFetch()

    useEffect(() => {

        isAuthenticated && (() => {
            loadData()
        })()
    }, [isAuthenticated])

    
    const loadData = () => {
        fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/retrieveshot?clipname=${clipname}`, {headers:{'X-Project-ID': projectContext?.project_db}})
            .then((res) => res.json())
            .then(
                (result) => {
                    setShotData(result)
                },
                (error) => {
                    //console.log(error);
                },
        );
    }

    return (
        <React.Fragment>
            <Box
                bgcolor='rgba(0,0,0,0.8)'
                sx={{
                    width: '100%',
                    height: '100%',
                }}
            >
                {
                    shotData &&
                    (isSm
                    ?
                    <ShotDetailPageMobile
                        shotData={shotData}
                    />
                    :
                    <ShotDetailPageDesktop
                        shotData={shotData}
                    />
                    )
                }
            </Box>
        </React.Fragment>
    );
}